'use strict';

function safeRelativePath(value) {
  if (
    typeof value !== 'string' ||
    !value ||
    /^[A-Za-z][A-Za-z0-9+.-]*:\/\//.test(value) ||
    /^[A-Za-z]:[\\/]/.test(value) ||
    Array.from(value).some(
      (char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127
    ) ||
    value.startsWith('/') ||
    value.includes('//')
  )
    return false;
  // A trailing slash is meaningful for directory listing. Interior empty or
  // traversal segments are never allowed, including in configured roots.
  const segments = value.replace(/\/$/, '').split('/');
  return segments.every(
    (segment) => segment && segment !== '.' && segment !== '..'
  );
}

/** Resolve producer output-root-relative values to the selected bucket's key. */
function resolveNextflowArtifactPath(value, location) {
  if (!safeRelativePath(value)) return null;
  const outputDir = location?.outputDir;
  if (outputDir == null || outputDir === '') return value;
  if (
    typeof outputDir !== 'string' ||
    outputDir !== outputDir.trim() ||
    /[?#]/.test(outputDir)
  )
    return null;

  // Parse without URL normalization: URL would silently erase ../ segments.
  // Only persisted same-bucket object-store roots can supply a prefix.
  const match = /^(?:gs|s3):\/\/([a-z0-9][a-z0-9._-]*)(?:\/(.*))?$/.exec(
    outputDir
  );
  if (!match || match[1] !== location?.bucketName) return null;
  const configuredPath = match[2] || '';
  if (configuredPath && !safeRelativePath(configuredPath)) return null;
  const prefix = configuredPath.replace(/\/$/, '');
  if (!prefix) return value;

  // Producer values are relative to outputDir even when they share its first
  // segments. Never infer a bucket-relative path from matching characters.
  return `${prefix}/${value}`;
}

module.exports = { resolveNextflowArtifactPath };
